// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__31EP1","audit":"styles_audit__1VgZF","content":"styles_content__2IJ0X","btn":"styles_btn__2muga"};